import type { IconSvgObject } from './types';

const CigaretteIcon: IconSvgObject = [
  ["path", { d: "M18 19H3C2.44772 19 2 18.5523 2 18V16C2 15.4477 2.44772 15 3 15H18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M21 15C21.5523 15 22 15.4477 22 16V18C22 18.5523 21.5523 19 21 19", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M22 12V9C22 7.89543 21.1046 7 20 7H15C13.8954 7 13 6.10457 13 5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M15 10H18C18.5523 10 19 10.4477 19 11V12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M7 15V19", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }]
];

export default CigaretteIcon;
